// API client (OAuth 2.0 client credentials) scope configuration.
//
// A scope is written as `[entity]:[action]`. Both the entity list and the action
// list are expected to grow over time — keep this file as the single source of
// truth and the UI will pick changes up automatically.
//
// Scope/IP/secret helpers live in `utils/apiClient`.

export type ApiScopeAction = 'read' | 'create' | 'update' | 'delete'

export interface ApiScopeEntity {
  key: string
  label: string
}

// `read` must always come first — it is the implicit prerequisite for every
// other action on the same entity (see `validateScopes`).
export const API_SCOPE_ACTIONS: ApiScopeAction[] = ['read', 'create', 'update', 'delete']

export const API_SCOPE_ENTITIES: ApiScopeEntity[] = [
  { key: 'users', label: 'Users' },
  { key: 'positions', label: 'Positions' },
  { key: 'locations', label: 'Locations' },
  { key: 'business_units', label: 'Business Units' }
]

// Docs link shown above the API clients table.
export const API_DOCS_URL = '/api/v2/docs'

export const EXPIRATION_MIN_DAYS = 1
export const EXPIRATION_MAX_DAYS = 730
